import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "pages/Home";
import NotFound from "pages/NotFound";
const SeafilecombyhtmltodesignFREEversion10032023 = React.lazy(() =>
  import("pages/SeafilecombyhtmltodesignFREEversion10032023")
);
const ProjectRoutes = () => {
  return (
    <React.Suspense fallback={<>Loading...</>}>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<NotFound />} />
          <Route
            path="/seafilecombyhtmltodesignfreeversion10032023"
            element={<SeafilecombyhtmltodesignFREEversion10032023 />}
          />
        </Routes>
      </Router>
    </React.Suspense>
  );
};
export default ProjectRoutes;
